<template>
  <button
    id="phone-button"
    type="button"
    :class="buttonClass"
    @click.stop="onClick"
  >
    <component
      :is="buttonSvgComponent"
      :size="isDetailView ? '18' : '24'"
    />
    <span
      v-if="showText"
      :class="!isDetailView ? 'ml-1' : null"
      v-text="buttonText"
    ></span>
  </button>
</template>

<script>
  export default {
    components: {
      SvgIconPhone: () =>
        import(/* webpackChunkName: "chunk-svg-icon-phone" */ './svg/icon-phone.vue'),
      SvgIconPhoneAlt: () =>
        import(/* webpackChunkName: "chunk-svg-icon-phone-alt" */ './svg/icon-phone-alt.vue'),
    },
    props: {
      value: {
        type: String,
        required: true,
      },
      showMaskedText: {
        type: Boolean,
        default: false,
      },
      isDetailView: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        eventName: 'phone-button:show-telephone-number',
        listeningToEvent: false,
        showText: false,
        showingValue: false,
        ignoreMultipleDesktopClicks: false,
      }
    },
    computed: {
      buttonSvgComponent() {
        return this.isDetailView ? 'svg-icon-phone-alt' : 'svg-icon-phone'
      },
      buttonClass() {
        return {
          btn: true,
          'btn-primary btn-phone btn-block': this.isDetailView,
          'btn-contact-rounded text-primary': !this.isDetailView,
          'btn-phone-disabled w-auto px-3': this.showText && !this.isDetailView,
        }
      },
      buttonText() {
        if (!this.showingValue && this.showMaskedText && this.isDetailView) {
          return this.$root.isMobile ? gettext('call me') : gettext('telephone')
        }

        if (this.value && this.value.length >= 3) {
          return `${this.value.slice(0, 3)}\u200B${this.value.slice(3)}`
        }

        return this.value
      },
      href() {
        return `tel:${this.value}`
      },
    },
    mounted() {
      if (this.isDetailView) {
        this.showText = true
        this.listeningToEvent = true
        window.addEventListener(this.eventName, this.displayValue)
      }
    },
    beforeDestroy() {
      if (this.listeningToEvent) {
        window.removeEventListener(this.eventName, this.displayValue)
      }
    },
    methods: {
      displayValue(event) {
        if (!event || !event?.detail?.mobile || event?.detail?.number === this.value) {
          this.showText = true
          this.showingValue = true
        }
      },
      onClick() {
        if (this.ignoreMultipleDesktopClicks) {
          return
        }

        if (!window.app.isMobile) {
          this.ignoreMultipleDesktopClicks = true
          const event = new CustomEvent(this.eventName, {
            detail: {
              number: this.value,
              mobile: false,
            },
          })
          window.dispatchEvent(event)

          if (!this.listeningToEvent) {
            this.displayValue(null)
          }
        } else {
          window.location.href = this.href
        }

        // analytics
        this.$emit('analytics')
      },
    },
  }
</script>
<style>
  @media (max-width: 768px) {
    #phone-button {
      white-space: nowrap;
    }
  }
</style>
